
// export class BaseResponse {
//     public result: boolean;
//     public errorCode: number;
//     public errorMessage: string;
//     public errors: string[];
//     public warnings: string[];
//     public errorDetails: string[];

//     public constructor(init?: Partial<BaseResponse>) { (Object as any).assign(this, init); }
// }
// export interface IReturn<TResponse> {
//     createResponse(): TResponse;
// }


//Cursor Dtos

export class TemgenelSpimzayetkilidoldur_CursorDto {
    UNVAN_TURU: string;
    ADI_SOYADI: string;
    KOD: number;

    public constructor(item?: any) {
        this.UNVAN_TURU = item.UNVAN_TURU;
        this.ADI_SOYADI = item.ADI_SOYADI;
        this.KOD = item.KOD;
    }
}


export class GenSpsmstelkontrol_CursorDto {
    AD_SOYAD: string;
    METIN: string;
    GSM_NO: string;
    PO_HATA: string;

    public constructor(item?: any) {
        this.AD_SOYAD = item.AD_SOYAD;
        this.METIN = item.METIN;
        this.GSM_NO = item.GSM_NO;
        this.PO_HATA = item.PO_HATA;
    }
}

export class GenSpmahalle_CursorDto {
    KOD: number;
    AD: string;
    KAPANIS_TARIHI: string;

    public constructor(item?: any) {
        this.KOD = item.KOD;
        this.AD = item.AD;
        this.KAPANIS_TARIHI = item.KAPANIS_TARIHI;
    }
}

export class GenSpiller_CursorDto {
    KOD: number;
    ACIKLAMA: string;

    public constructor(item?: any) {
        this.KOD = item.KOD;
        this.ACIKLAMA = item.ACIKLAMA;
    }
}

export class GenSpilceler_CursorDto {
    KOD: number;
    ACIKLAMA: string;

    public constructor(item?: any) {
        this.KOD = item.KOD;
        this.ACIKLAMA = item.ACIKLAMA;
    }
}

export class GenSpcaddesokak_CursorDto {
    MAHALLE_CADDE_SOKAK_KOD: number;
    CADDE_SOKAK_AD: string;

    public constructor(item?: any) {
        this.MAHALLE_CADDE_SOKAK_KOD = item.MAHALLE_CADDE_SOKAK_KOD;
        this.CADDE_SOKAK_AD = item.CADDE_SOKAK_AD;
    }
}




export class CmyaraAracmybirimkullaniciatanan_CursorDto {
    Kod: number;
    Adi: string;
    Soyadi: string;
    constructor(item?: any) {

        this.Kod = item?.Kod || 0;
        this.Adi = item?.Adi || '';
        this.Soyadi = item?.Soyadi || '';
    }
}

export class CmygenelSpbirimpersonelliste_CursorDto {
    Kod: number;
    BirimKod: number;
    KullaniciKod: number;
    Adi: string;
    Soyadi: string;
    IsSiraNo: string;
    constructor(item?: any) {

        this.Kod = item?.Kod || 0;
        this.BirimKod = item?.BirimKod || 0;
        this.KullaniciKod = item?.KullaniciKod || 0;
        this.Adi = item?.Adi || '';
        this.Soyadi = item?.Soyadi || '';
        this.IsSiraNo = item?.IsSiraNo || '';
    }
}

export class CmygenelSpsevkbirimler_CursorDto
{Kod : number;
BelediyeKod : number;
KonuKod : number;
BirimKod : number;
BirimAd : string;
KullaniciKod : number;
KullaniciAd : string;
IsSiraNo : number;
KayitTarih : Date;
KayitKullaniciKod : number;
DegisTarih : Date;
DegisKullaniciKod : number;
KayitSayisi : number;
RowNo : number;
constructor(item?:any){
this.Kod = item?.Kod ||0;
this.BelediyeKod = item?.BelediyeKod ||0;
this.KonuKod = item?.KonuKod ||0;
this.BirimKod = item?.BirimKod ||0;
this.BirimAd = item?.BirimAd ||'';
this.KullaniciKod = item?.KullaniciKod ||0;
this.KullaniciAd = item?.KullaniciAd ||'';
this.IsSiraNo = item?.IsSiraNo ||0;
this.KayitTarih = item?.KayitTarih ||new Date();
this.KayitKullaniciKod = item?.KayitKullaniciKod ||0;
this.DegisTarih = item?.DegisTarih ||new Date();
this.DegisKullaniciKod = item?.DegisKullaniciKod ||0;
this.KayitSayisi = item?.KayitSayisi ||0;
this.RowNo = item?.RowNo ||0;}
}

export class SysgenelSpincelemelersonuciptal_CursorDto
{Kod : number;
SosyalBasvuruKod : number;
SosyalBasvuruDetayKod : number;
PlanTarihi : string;
Durumu : string;
TeslimTarihi : string;
TeslimEden : string;
Malzeme : string;
constructor(item?:any){
this.Kod = item?.Kod ||0;
this.SosyalBasvuruKod = item?.SosyalBasvuruKod ||0;
this.SosyalBasvuruDetayKod = item?.SosyalBasvuruDetayKod ||0;
this.PlanTarihi = item?.PlanTarihi ||'';
this.Durumu = item?.Durumu ||'';
this.TeslimTarihi = item?.TeslimTarihi ||'';
this.TeslimEden = item?.TeslimEden ||'';
this.Malzeme = item?.Malzeme ||'';}
}

